import React, { useState, useEffect } from "react";
import { SVGAsset } from "res";

/**
 * @function UIEditPhoneInput
 * @param {STRING} className - Additional css class
 * @param {STRING} value - The value that should be set for the text field
 * @param {STRING} placeHolder - The placeholder that should be shown if nothing is in the field
 * @param {FUNCTION} onChange - A function to be ran when the value is updated in the field
 * @returns {React.Component}
 * @example <UIEditPhoneInput value="(123) 456-1234" onChange={ value => { ... } } />
 */
export default function UIEditPhoneInput(props) {
    //const [ state, setState ] = useState(props.value ?? "");
    const inputField = React.createRef();

    const className = props.className ?? "";
    const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
    const isEditing = String(props.isEditing) === "true";
    const allowEditing = String(props.allowEditing) === "true";
    const [ state, setState ] = useState({ value: props.value ?? "", edit: isEditing });
    const label = props.label ?? "";
    const changeLabel = `Change ${ label.toLowerCase() }`;
    const removeFormRowBottomMargin = state.value === "";
    const formRowBottomMarginRemovedClass = removeFormRowBottomMargin ? "form-row-removed-bottom-margin" : "";
    const onEditClick = () => setState({ ...state, edit: true });

    const editLink = (
    <a onClick={ onEditClick }>
        <span className="flex-container flex-horizontal align-center edit-link">
            <SVGAsset id="EditIcon" />
            <p>Edit</p>
        </span>
    </a>
    );

    const onChange = evt => {
        // Get the value from the input field
        let value = inputField.current.value;
        // Remove all characters that aren't a number
        value = value.replace(/[^0-9]/g, "");
        // If the key that was pressed was the delete button
        if(evt.nativeEvent.inputType === "deleteContentBackward") {
            // Use the value set in state (should have the value before the delete was pressed)
            value = state.value.replace(/[^0-9]/g, "");
            // With all the non number characters removed, remove that last value
            value = value.slice(0, value.length - 1);
        }

        const areaCode = value.substring(0, 3).length > 0 ? `(${ value.substring(0, 3) })` : "";
        const firstThree = value.substring(3, 6).length > 0 ? ` ${ value.substring(3, 6) }` : "";
        const lastFour = value.substring(6, 10).length > 0 ? `-${ value.substring(6, 10) }` : "";
        // Create the phone value and update state
        value = `${ areaCode }${ firstThree }${ lastFour }`;
        setState({ ...state, value: value });
        // If the onChange property is a function then run the on change passing the value
        if(props.onChange instanceof Function) {
            props.onChange(value);
        }
    };  
    // If the value set in the props was updated, then update the state with the new value
    //useEffect(() => setState(props.value ?? ""), [ props.value ]);
    useEffect(() => setState({ ...state, value: props.value ?? "" }), [ props.value ]);

    return (
        <div className={`form-row flex-height uitextinput edit ${className}${ formRowBottomMarginRemovedClass }`}>
            {/* Default state. */}
            { !state.edit &&
                <>
                { state.value === "" &&
                    <div className="flex-container flex-horizontal">
                        <div className="flex-width text-input-label">{ label }</div>
                        { allowEditing && editLink }
                    </div>
                }
                { state.value !== "" && 
                    <>
                        <div className="text-input-label">{ label }</div>
                        <div className="flex-container flex-horizontal">
                            <div className="flex-width gray-text">{ state.value }</div>
                            { allowEditing && editLink }
                        </div>
                    </>
                }
                </>
            }
            {/* Editing state. */}
            { state.edit && 
                <>
                    <div className="text-input-label">{ changeLabel }</div>
                    <div className={`form-row flex-height uitextinput edit ${className}`}>
                        <div className="floating-label-input-container">
                            <input className="floating-label-input form-row-input" ref={ inputField }
                            type="text" placeholder=" " value={ state.value } onChange={ onChange } { ...dataPoint }></input>
                            <label className="floating-label form-row-label">{props.placeHolder}</label>
                        </div>
                        <span className="form-row-info-text gray-text">
                            {props.children}
                        </span>
                    </div>
                </>
            }
        </div>
    );
}